import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesTypesScreenSchemesDeleteRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-types-screen-schemes-delete',
	path: '/secure/admin/ViewDeleteIssueTypeScreenScheme.jspa',
};
